<template>
  <div>
    <b-card-header header-tag="header" class="p-1" role="tab">
      <span v-b-toggle="'id-' + message.NR" class="no-outline">
        <span class="when-closed">
          <div class="flex-parent">
            <div class="long-and-truncated">
              <img :src="icon" alt="check" class="pb-1" />
              <span class="font-weight-bold pr-2 w-50">{{ title }}</span>
              <span>{{ message.TEMAT }}</span>
              <span class="ml-auto"><i class="fas fa-chevron-down"></i></span>
            </div>
            <div>
              <span class="float-right mr-2 mt-1 font-italic">{{
                formatDate(message.DATA)
              }}</span>
            </div>
          </div>
        </span>
        <span class="when-open">
          <div class="flex-parent">
            <div class="long-and-truncated">
              <img :src="icon" alt="check" class="pb-1" />
              <span class="font-weight-bold pr-2 w-50">{{ title }}</span>
              <span>{{ message.TEMAT }}</span>
              <span class="ml-auto"><i class="fas fa-chevron-up"></i></span>
            </div>
            <div>
              <span class="float-right mr-2 mt-1 font-italic">{{
                message.DATA
              }}</span>
            </div>
          </div>
        </span>
      </span>
    </b-card-header>
    <b-collapse
      :id="'id-' + message.NR"
      accordion="my-accordion"
      role="tabpanel"
      :visible="index === 0"
    >
      <b-card-body>
        <b-embed
          type="iframe"
          class="embed-responsive-4by3"
          aspect="4by3"
          :src="url"
        ></b-embed>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Message',
  props: {
    message: {
      required: true,
      type: Object,
    },
    program: {
      required: true,
      type: String,
    },
    styles: {},
    index: {},
  },
  data() {
    return {
      url: '',
    };
  },
  computed: {
    icon() {
      if (this.message.TYP === 1) {
        return this.styles.wazne;
      } else if (this.message.TYP === 2) {
        return this.styles.porady;
      } else if (this.message.TYP === 3) {
        return this.styles.porady;
      } else if (this.message.TYP === 4) {
        return this.styles.aktualnosci;
      } else if (this.message.TYP === 5) {
        return this.styles.artykuly;
      } else if (this.message.TYP === 6) {
        return this.styles.awarie;
      } else if (this.message.TYP === 7) {
        return this.styles.opieka;
      } else if (this.message.TYP === 8) {
        return this.styles.zmiany;
      } else {
        return this.styles.promocje;
      }
    },
    title() {
      if (this.message.TYP === 1) {
        return 'Ważne';
      } else if (this.message.TYP === 2) {
        return 'Porady dnia';
      } else if (this.message.TYP === 3) {
        return 'Inne';
      } else if (this.message.TYP === 4) {
        return 'Aktualności';
      } else if (this.message.TYP === 5) {
        return 'Artykuły';
      } else if (this.message.TYP === 6) {
        return 'Awarie';
      } else if (this.message.TYP === 7) {
        return 'Opieka Serwisowa';
      } else if (this.message.TYP === 8) {
        return 'Ostatnie zmiany';
      } else {
        return 'Promocje';
      }
    },
  },
  created() {
    if (this.program === 'skp') {
      this.url =
        'https://www.format.wroc.pl/centrum_serwisowe/komunikaty/skp/index.php?nr=' +
        this.message.NR;
    } else if (this.program === 'sam') {
      this.url =
        'https://www.format.wroc.pl/centrum_serwisowe/komunikaty/sam/index.php?nr=' +
        this.message.NR;
    }
  },
  methods: {
    formatDate(value) {
      return moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY');
    },
  },
};
</script>

<style>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.flex-parent {
  display: flex;
}

.long-and-truncated {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.long-and-truncated img {
  max-width: 25px;
}
</style>
